import type { FormState, RegisterReference } from '@/shared/types/users.types';
import type { C } from '@/utils/colorHelpers';

export function StepAvailability({
    form,
    toggleSlot,
    toggleZone,
    reference,
    c,
}: {
    form: FormState;
    toggleSlot: (id: number) => void;
    toggleZone: (id: number) => void;
    reference: RegisterReference;
    c: C;
}) {
    return (
        <div className="space-y-5">
            <h2 className="text-xl font-semibold text-gray-900">Disponibilité et zones</h2>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Créneaux *</label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {reference.availability_slots.map(slot => (
                        <label
                            key={slot.id}
                            className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer p-2 border rounded-lg hover:bg-gray-50"
                        >
                            <input
                                type="checkbox"
                                checked={form.availabilitySlotIds.includes(slot.id)}
                                onChange={() => toggleSlot(slot.id)}
                                className="rounded border-gray-300"
                            />
                            <span>
                                {slot.name}
                                {slot.start_time && slot.end_time
                                    ? ` (${slot.start_time.slice(0, 5)}–${slot.end_time.slice(0, 5)})`
                                    : ''}
                            </span>
                        </label>
                    ))}
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Zones de couverture *</label>
                <div className="grid grid-cols-2 gap-2 max-h-48 overflow-y-auto">
                    {reference.zones.map(zone => (
                        <label
                            key={zone.id}
                            className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer p-2 border rounded-lg hover:bg-gray-50"
                        >
                            <input
                                type="checkbox"
                                checked={form.coverageZoneIds.includes(zone.id)}
                                onChange={() => toggleZone(zone.id)}
                                className="rounded border-gray-300"
                            />
                            {zone.name}
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
}
